import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Capabilities from "@/components/site/Capabilities";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import Quality from "@/components/site/Quality";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="relative bg-background" data-testid="landing-page">
        <div className="grain" />
        <Header />
        <main>
          <Hero />
          <About />
          <Capabilities />
          <Services />
          <Industries />
          <Quality />
          <MarqueeStrip />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
